class BaseSubmitObjectForWorkbook {
    //BaseReportInputModel
    //reportId
    drilldownId: number = 0;
    resetDrilldown: boolean = true;
    //[JsonConverter(typeof (StringEnumConverter))]
    reportType: ReportTypeEnum;

    //BaseTabInputModel
    tabId: number;
    widgetId: number;
    //classic: false,

    //BaseWorkbookInputModel
    workbookId: number;
    //WorkbookName
    //CopyScheduledEmails
    //Editing
    mappingId: number;

    //BaseConfigInputModel
    //FilterChangeModel GlobalFilters
    //FilterChangeModel TabFilters
    //List<WidgetFilterChangeModel> WidgetFilters
    //UpdateNextDrilldownInputModel NextDrilldown
    nextDrilldown: {
        newReportId: number;
        newDrilldownId: number;
        //widgetId: 0, //Unused at present...for future use... is that right??
    };

    //UpdateDrilldownReportsInputModel
    reports: Array<any> = [];

    //ChangeReportInputModel
    newReportId: number = 0;

    //UpdateReportInputModel
    groupReportId: number;

    //ChartDefinitionReportInputModel
    chartDefinition: string = "";
    metricFields: string = "";

    //SaveReportSettingsVM
    reportConfig: string = "";

    //NavigateToDrilldown
    newDrilldownId: number = 0;
    tabValues: Array<FilterValuesVM> = [];
    fromTabDetail: number = 0;
    fromTabDetailWidget: number = 0;

    //WidgetConfigInputModel
    config: string;

    //WidgetSettingsInputModel
    layout: string;
    tabDetailId: number;
    copyMetricsToTab: boolean;
    copyDimensionsToTab: boolean;
    appearance: string; //AppearanceConfig;

    //FilterDataSourceModel
    scope: ContainerScopeEnum;
    filterId: string;
    filterTemplateId: number;
    isNewFilter: boolean;
    filter: Filter;

    //UpdateTopBottomInputModel
    resultCount: number;
    topBottom: number;
    orderField: string;
    resultCountGroupBy: number;
    topBottomGroupBy: number;
    orderFieldGroupBy: string;

    //TemplatesFieldsVM
    templateId: number;

    scheduledEmailId: number;

    //UpdateWidgetInputModel
    widgetType: WidgetType;

    isEmailBody: boolean;

    constructor(tab: WorkbookTab, widget: DashboardWidget = null) {
        //BaseReportInputModel
        //reportId
        //drilldownId
        //[JsonConverter(typeof (StringEnumConverter))]
        //ReportType ReportType

        //BaseTabInputModel
        this.tabId = tab.id();
        this.widgetId = widget?.id() ?? 0;
        //classic: false,

        //BaseWorkbookInputModel
        this.workbookId = tab.workbookConfig.workbookId();
        //WorkbookName
        //CopyScheduledEmails
        //Editing
        this.mappingId = tab.workbookConfig.mappingId;

        this.scheduledEmailId = tab.workbookConfig.isPrinting || tab.workbookConfig.isExcelPrinting ? tab.workbookConfig.scheduledEmailId : null;
        this.isEmailBody = tab.workbookConfig.isEmailBody;

        //BaseConfigInputModel
        //FilterChangeModel GlobalFilters
        //FilterChangeModel TabFilters
        //List<WidgetFilterChangeModel> WidgetFilters
        //UpdateNextDrilldownInputModel NextDrilldown
        this.nextDrilldown = {
            newReportId: 0,
            newDrilldownId: 0,
            //widgetId: 0, //Unused at present...for future use... is that right??
        };
    }
}